import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-navy-dark text-cream pt-24 pb-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-16 mb-20">
          <div className="max-w-md">
            <h2 className="font-fraunces text-4xl mb-6">Pronto Notary</h2>
            <p className="text-cream/60 leading-relaxed">
              Mobile notary and apostille services in Laurel, Maryland. Bilingual English and Português. Evenings and weekends. NNA member, E&O insured, background screened.
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-12">
            <div className="sm:col-span-1">
              <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Services</h4>
              <ul className="space-y-3">
                <li><a href="/services/mobile-notary" className="text-sm text-cream/70 hover:text-brass transition-colors">Mobile Notary</a></li>
                <li><a href="/services/remote-online-notary" className="text-sm text-cream/70 hover:text-brass transition-colors">Remote Online Notary</a></li>
                <li><a href="/services/general-notarizations" className="text-sm text-cream/70 hover:text-brass transition-colors">General Notarizations</a></li>
                <li><a href="/services/apostille" className="text-sm text-cream/70 hover:text-brass transition-colors">Apostille Services</a></li>
                <li><a href="/services/i-9-employment-verification" className="text-sm text-cream/70 hover:text-brass transition-colors">I-9 Employment Verification</a></li>
                <li><a href="/services/business-corporate" className="text-sm text-cream/70 hover:text-brass transition-colors">Business &amp; Corporate</a></li>
                <li><a href="/services/medical-healthcare" className="text-sm text-cream/70 hover:text-brass transition-colors">Medical &amp; Healthcare</a></li>
                <li><a href="/services/family-estate-planning" className="text-sm text-cream/70 hover:text-brass transition-colors">Family &amp; Estate Planning</a></li>
                <li><a href="/services/vehicle-documents" className="text-sm text-cream/70 hover:text-brass transition-colors">Vehicle Documents</a></li>
              </ul>
            </div>

            <div className="sm:col-span-1">
              <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Service Areas</h4>
              <ul className="space-y-3">
                <li><a href="/mobile-notary/laurel" className="text-sm text-cream/70 hover:text-brass transition-colors">Laurel, MD</a></li>
                <li><a href="/mobile-notary/college-park" className="text-sm text-cream/70 hover:text-brass transition-colors">College Park, MD</a></li>
                <li><a href="/mobile-notary/beltsville" className="text-sm text-cream/70 hover:text-brass transition-colors">Beltsville, MD</a></li>
                <li><a href="/mobile-notary/greenbelt" className="text-sm text-cream/70 hover:text-brass transition-colors">Greenbelt, MD</a></li>
                <li><a href="/mobile-notary/silver-spring" className="text-sm text-cream/70 hover:text-brass transition-colors">Silver Spring, MD</a></li>
                <li><a href="/mobile-notary/aspen-hill" className="text-sm text-cream/70 hover:text-brass transition-colors">Aspen Hill, MD</a></li>
                <li><a href="/mobile-notary/rockville" className="text-sm text-cream/70 hover:text-brass transition-colors">Rockville, MD</a></li>
                <li><a href="/mobile-notary/gaithersburg" className="text-sm text-cream/70 hover:text-brass transition-colors">Gaithersburg, MD</a></li>
              </ul>
            </div>

            <div className="sm:col-span-1">
              <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Contact</h4>
              <div className="space-y-6">
                <div>
                  <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Call or Text</h4>
                  <a href="tel:2405713117" className="text-sm font-semibold hover:text-brass transition-colors">
                    (240) 571-3117
                  </a>
                </div>
                <div>
                  <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Email</h4>
                  <a href="mailto:carlos@prontonotarymd.com" className="text-sm font-semibold hover:text-brass transition-colors">
                    carlos@prontonotarymd.com
                  </a>
                </div>
                <div>
                  <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Location</h4>
                  <p className="text-sm font-semibold">Laurel, MD 20707</p>
                </div>
                <div>
                  <h4 className="text-brass font-bold text-xs uppercase tracking-widest mb-4">Hours</h4>
                  <p className="text-sm font-semibold">Mon–Fri: 5:00 PM–10:00 PM</p>
                  <p className="text-xs text-cream/50 mt-1">(weekday mornings by appointment)</p>
                  <p className="text-sm font-semibold mt-1">Sat–Sun: 8:00 AM–9:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-6 pt-12 border-t border-brass/20">
          <p className="text-[11px] text-cream/40 italic leading-relaxed max-w-3xl">
            Legal disclaimer: Pronto Notary is not a law firm and does not provide legal advice. Carlos M Dasilva is a commissioned notary public in the State of Maryland. Notarial acts performed are governed by Maryland law.
          </p>
          <p className="text-[11px] text-cream/40 italic leading-relaxed max-w-3xl">
            A Pronto Notary não é um escritório de advocacia e não oferece consultoria jurídica. Carlos M Dasilva é um notário público comissionado no Estado de Maryland. Importante: nos EUA, um notário público (notary public) tem funções diferentes do cartório no Brasil.
          </p>
        </div>

        <div className="mt-20 pt-8 border-t border-cream/5 text-center">
          <p className="text-[10px] text-cream/20 tracking-widest uppercase">
            &copy; {new Date().getFullYear()} Pronto Notary. Maryland Commission expires May 12, 2030. All rights reserved.
          </p>
          <div className="mt-5 flex justify-center gap-6 text-xs text-cream/50">
            <a href="/privacy-policy" className="hover:text-brass transition-colors">
              Privacy Policy
            </a>
            <a href="/terms-of-service" className="hover:text-brass transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;